import { ChainId, Token, Tokens } from '../../constants';
import React from 'react';
import Button from '../Button';
import ERC20_ABI from '@/contracts/erc20.json';
import styled from 'styled-components';
import { useAccount, useChainId } from 'wagmi';
import { Contract } from 'ethers';
import { useEthersProvider } from '@/hooks/useEthersProvider';

const StyledButton = styled(Button)`
    color: #64d9cd !important;
    box-sizing: border-box;
    padding: 6px 12px !important;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    font-size: 14px !important;
    background: transparent;
    border: none;
    /* &:hover {
        background-color: #122537;
    } */
    .loadingIcon {
        color: #122537;
        font-size: 20px;
    }
`;

interface Props {
    token: Token;
}

export default function AddToken({ token }: Props) {
    const chainId = useChainId() as ChainId;
    const { connector } = useAccount();
    const provider = useEthersProvider({ chainId });

    async function addToken() {
        try {
            const tokenConfig = Tokens[token];
            if (!tokenConfig) {
                console.error(`Token ${token} not found in configuration`);
                return;
            }

            const tokenInfo = tokenConfig[chainId as keyof typeof tokenConfig];

            if (!tokenInfo) {
                console.error(
                    `Token ${token} not supported on chain ${chainId}`,
                );
                return;
            }

            const { address, symbol, img } = tokenInfo;

            if (!address) {
                console.error(
                    `Token ${token} has no address on chain ${chainId}`,
                );
                return;
            }

            // Get provider instance first
            const providerInstance = await connector?.getProvider();
            if (
                !providerInstance ||
                typeof providerInstance !== 'object' ||
                !('request' in providerInstance)
            ) {
                console.error('Provider not available');
                return;
            }

            let decimals = 18; // default decimals

            // Get decimals from contract using provider
            try {
                if (provider && address) {
                    const contract = new Contract(address, ERC20_ABI, provider);
                    const contractDecimals = await contract.decimals();
                    decimals = Number(contractDecimals);
                }
            } catch (error) {
                console.warn(
                    'Failed to get decimals from contract, using default:',
                    error,
                );
                // Keep default decimals value
            }

            // Add token to wallet
            const params: any = {
                type: 'ERC20',
                options: {
                    address: address,
                    symbol: symbol,
                    decimals: decimals,
                    image:
                        typeof img === 'string'
                            ? img
                            : `https://bridge.metis.io/logo.png`,
                },
            };

            const success = await (providerInstance as any).request({
                method: 'wallet_watchAsset',
                params,
            });

            if (success) {
                console.log(`Successfully added ${symbol} to wallet`);
            } else {
                console.log('User declined to add token');
            }
        } catch (error) {
            console.error('Error adding token:', error);
            // Rethrow to let Button component handle the error state
            throw error;
        }
    }

    return (
        <StyledButton
            onClick={addToken}
            type="transparent"
            showLoading
            loadingProps={{
                // classname: style.loadingIcon,
                size: 24,
            }}
        >
            Add to wallet
        </StyledButton>
    );
}
